// extracted by mini-css-extract-plugin
export default {"editWrapper":"EditTopicName_editWrapper__nKcew","textField":"EditTopicName_textField__HTaG+","keyWordsType":"EditTopicName_keyWordsType__+b6rj"};